
import { Prop, Vue, Component } from 'vue-property-decorator';
import BaseButton from './ui/BaseButton.vue';
import IconBox from '../assets/icon/icon-box.svg'
import IconSale from '../assets/icon/icon-sale.svg'

@Component({
    components: {
        IconBox, IconSale, BaseButton
    }
})
export default class Card extends Vue {
    @Prop({ default: '' }) readonly img?: string;
    @Prop({ required: true, default: '25%' }) readonly discount?: string;
    @Prop({ default: false }) readonly hitSales?: boolean;
    @Prop({ required: true, default: 'Бренд' }) readonly brand!: string;
    @Prop({ required: true, default: 'Полное название товара в несколько строк для вида с обрывом в конце...' }) readonly description!: string;
    @Prop({ required: true }) readonly price!: number;
    @Prop({ required: true }) readonly pastPrice!: number;
    @Prop({ required: true }) readonly inStock!: boolean;
}
